export enum DashboardOPEEnum {
  DelDashboard = 'delDashboard',
  PutDashboard = 'putDashboard',
  GetDashboards = 'getDashboards',
  GetAllUserDashboards = 'getAllUserDashboards',
  ShareDashboard = 'shareDashboard',
  ValidateShareDraft = 'validateShareDraft',
  DelDashboardWidget = 'delDashboardWidget',
  PutDashboardWidget = 'putDashboardWidget',
  GetDashboardWidgets = 'getDashboardWidgets',
  GetAllUserDashboardWidgets = 'getAllUserDashboardWidgets',
  DelWidget = 'delWidget',
  PutWidget = 'putWidget',
  GetWidgets = 'getWidgets'
}
